import { memo, useCallback, useRef, useState, useEffect } from "react";
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles'
import { Grid, Box, Modal, Fade,Typography,Button} from "@mui/material";
import { useSelector, useDispatch } from 'react-redux'

import ReportHeaderNew from "./ReportHeaderNew";
import ReportSidebarNew from "./ReportSidebarNew";
import Limit from '../../components/common/Limit'
import ReportVisualizeTab from "./ReportSidebar/ReportVisualizeTab";
import ReportGraphNew from "./ReportGraphNew";
import ReportFilterTab from "./ReportSidebar/ReportFilterTab";
import ReportSettingsTab from "./ReportSidebar/ReportSettingsTab";
import { removeReference, updateQuery } from "../../utils/Reusables";
import ReportFieldWells from "./ReportFieldWells";
import { DecryptData, EncryptData } from "../../utils/encryptDecrypt";
import { reportActions } from "../../redux/reducers/report/reportReducer";
import ReportGraphFilters from "./ReportGraphFilters";

const RootStyle = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
})

const MainStyleWrapper = styled('div')(({ theme }) => ({
    height: '100%',
    width: '100%'
}))

const MainStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: 'calc(100% - 46px)',
    paddingTop: '0.5rem',
    paddingBottom: '0',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
        paddingTop: '0.5rem',
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        paddingBottom: '1rem',
    },
    [theme.breakpoints.down('sm')]: {
        paddingTop: '0rem',
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        paddingBottom: '3rem',
    },
}))
const DRAWER_WIDTH = 200;
const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "10%",
        width: "100"
    },
    graphFiltergrid: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '0rem',
            '& > .MuiGrid-item': {
                paddingTop: 0,
            },
        },
    },
    inputLabel: {
        minHeight: '21px',
    },
    reportSettings: {
        width: '100%',
        height: '100%',
        backgroundColor: '#FFE9E2',
        padding: '1rem',
        borderRadius: '8px',
    },
    drawerPaper: {
        width: DRAWER_WIDTH,
        backgroundColor: '#fff',
    },
    settingsBox: {
        width: '100%',
    },
}))
const defaultQuery = {measures:[],dimensions:[],filters:[],timeDimensions:[],limit:20,offset:0,total:true,renewQuery:true}
const NewReportLayout = ({ dataSetList }) => {
    const classes = useStyles(); 
    const reportDetails = useSelector(state => state.reportDetails)
    const dispatch = useDispatch()
    const reportContainerRef = useRef(null);    
    const [openSideBar, setOpenSideBar] = useState(true)
    const [ defaultLimit, setDefaultLimit ] = useState(20)
    const [selectedSidebarMenu, setSelectedSidebarMenu] = useState('Visualize')    
    const [selectedDataset, setSelectedDataset] = useState(dataSetList[0] ?? null)
    const [confirmDatasetChange,setConfirmDatasetChange] = useState(null)
    const [query,setQuery] = useState(defaultQuery)

    const onCloseSidebar = useCallback(() => {
        setOpenSideBar(false)
    })

    const onOpenSidebar = useCallback((menu) => {
        setOpenSideBar(true)
        setSelectedSidebarMenu(menu.title)
    })

    const handleReportLimit = useCallback((value) => {
        setDefaultLimit(value)
        updateQuery(query,{limit: value,offset:0},setQuery)
    })

    const handleConfirmDataSetChange = useCallback((event, value) => {
        if(query.measures.length > 0 || query.dimensions.length > 0){
            setConfirmDatasetChange(value)
        }else{
            onChangeDataset(value)
        }                
    })

    const onChangeDataset = useCallback((value) => {
        localStorage.setItem('selectedDataSetObjNew', EncryptData(JSON.stringify(value)))    
        setSelectedDataset(value)        
        setQuery(defaultQuery)
        dispatch(reportActions.reset())
    })

    const handleSubmitDataSetChange = useCallback((obj) => {
        if(obj.type === 'change'){
            onChangeDataset(confirmDatasetChange)
        }
        setConfirmDatasetChange(null)
    })

    useEffect(() => {
        let dataset = JSON.parse(DecryptData(localStorage.getItem("selectedDataSetObjNew"))) ?? dataSetList[0]
        setSelectedDataset(dataset)

        return () => {
            setQuery(defaultQuery)
        }
    },[])

    return <RootStyle>
        <ReportSidebarNew onOpenSidebar={onOpenSidebar} isOpenSidebar={openSideBar} onCloseSidebar={onCloseSidebar} selectedSidebarMenu={selectedSidebarMenu} />
        <MainStyleWrapper className="report-new-wrapper layout-wrapper">
            <ReportHeaderNew />
            <Grid container spacing={2} className="report-new-content" >
                <Grid item xs={12} md={openSideBar ? 4 : 0} className="report-new-main-fields" sx={{ display: (openSideBar) ? 'block' : 'none' }} alignItems="stretch"  >

                    {
                        openSideBar ?
                            <div className={classes.reportSettings}>
                                <Box variant="temporary" anchor="left" className={classes.settingsBox} classes={{ paper: classes.drawerPaper }}>
                                    <div className='report-settings-drawer'>
                                        {
                                            selectedSidebarMenu == 'Visualize' ?
                                                <ReportVisualizeTab handleConfirmDataSetChange={handleConfirmDataSetChange} selectedDataset={selectedDataset} query={query} setQuery={setQuery} dataSetList={dataSetList} />
                                                :
                                                selectedSidebarMenu == 'Filter' ?
                                                    <ReportFilterTab query={query} setQuery={setQuery} currentDataset={selectedDataset} />
                                                    :
                                                    <ReportSettingsTab currentDataset={selectedDataset} handleReportLimit={handleReportLimit} limitValue={defaultLimit}/>

                                        }

                                    </div>
                                </Box>
                            </div>
                            : ''
                    }
                </Grid>
                <Grid item xs={12} md={openSideBar ? 8 : 0} className="report-new-main-content" alignItems="stretch"  >
                    <Grid className="report-new-main-content-section" sx={{ height: '100%' }}>
                        <ReportFieldWells query={query} setQuery={setQuery} currentDataset={selectedDataset}/>
                        {
                            (reportDetails?.filters && reportDetails?.filters.filter(obj => obj.onReport)?.length > 0) && (
                                <ReportGraphFilters reportDetailsInfo={{reportDetails: {reportFilters: reportDetails?.filters}}} />
                            )
                        }

                        <MainStyle>
                            {
                                /*reportDetails.chartType == 'table' ? 
                                <Limit handleReportLimit={handleReportLimit} limitValue={defaultLimit} /> 
                                :'' */
                            }                            
                            <Grid item xs={12} className="report-graph-section" ref={reportContainerRef} >
                                <Box className={`report-graph-section-wrapper `}>
                                    {
                                        <ReportGraphNew query={removeReference(query)} reportDetails={removeReference(reportDetails)} selectedDataset={selectedDataset} />
                                    }
                                </Box>
                            </Grid>
                        </MainStyle>
                    </Grid>
                </Grid>
            </Grid>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className="modal-root"
                open={Boolean(confirmDatasetChange)}
                closeAfterTransition
                >
                <Fade in={Boolean(confirmDatasetChange)}>
                    <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                    <Box className="modal-content-simple">
                        <Typography variant="subtitle1" className="modal-heading-title-simple">{`Changing Dataset Will Reset Measures/Dimensions/Filters Selection. Are you sure to change it?`}</Typography>
                        <Box className="modal-footer-simple">
                        <Button onClick={() => handleSubmitDataSetChange({ type: 'cancel' })} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                        <Button onClick={() => handleSubmitDataSetChange({ type: 'change' })} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Change </Button>
                        </Box>
                    </Box>
                    </Box>
                </Fade>
            </Modal>         
        </MainStyleWrapper>
    </RootStyle>
}

export default memo(NewReportLayout)